import OurTeam from "./our-team";
export default OurTeam;